<div [id]="id()" data-uitype="graph-container" class="w-full h-full relative">
    @if (!loaded()) {
    <div
        class="absolute top-0 bottom-0 left-0 right-0 animate-pulse bg-dat-grey-100"
    ></div>
    }
    <div
        [class.opacity-0]="!loaded()"
        data-uitype="graph"
        #graph
        class="w-full min-h-[220px] h-full bg-white"
    ></div>
</div>
<section
    [class.opacity-0]="!loaded()"
    [id]="id() + '-legend'"
    [attr.data-testid]="id() + '-legend'"
    [attr.data-styletarget]="id() + '-legend'"
    class="flex items-center pl-6 pb-4"
>
    <span class="border-solid border-t-2 border-[#0097AF] w-5 h-0 mr-2"></span>
    <span class="text-sm">Trucks</span>
</section>
